import {
  Component,
  ElementRef,
  Input,
  NgModule,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash-es';
import {
  BackendSellDrugItemModel,
  BackendSellModel,
  SelectDrug,
} from '../../models/select-drug';
import { LoggerService } from 'src/app/services/logger.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { FloatLabelType } from '@angular/material/form-field';
import { FormControl, FormGroup } from '@angular/forms';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { TabelPaging } from '../../interfaces/table';
import { FocusableHTMLElement } from '../../interfaces/focusable-html-element';
import { CustomizeResponseService } from '../../services/customize-response.service';
import {
  BuyDrugViewModel,
  BuyImportRequestDrugModal,
  BuyImportRequestDrugStockModal,
  BuyImportRequestModal,
  BuyImportRequestValidationDrugModal,
  StockHelpItem,
} from '../../models/buy-import-modal';
import { Field } from '../../models/entity-defin';
import { debounceTime } from 'rxjs/operators';
import {
  FactorDetail,
  FactorStockItemDetailDrug,
} from '../../models/factor-detail';
import { ModalConfirm } from '../../models/modal-confirm';
import { CashMultiPaymentComponent } from '../../components/cash-multi-payment/cash-multi-payment.component';
import { Drug, DrugBackEndModel, DrugCode } from '../../models/drug';
import { DrugRequirementList } from '../../models/drug-requirement-list';
import { ProductType } from 'src/app/enum/product-type';
import { TranslateService } from '@ngx-translate/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NumericService } from 'src/app/services/numeric.service';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { Guid } from 'src/app/services/guid';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { Router } from '@angular/router';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { BarcodeService } from 'src/app/services/barcode.service';
import { DataService } from 'src/app/services/data.service';
import { BarcodeScannerComponent } from '../../components/barcode-scanner/barcode-scanner.component';
import { digitsEnToFa, digitsFaToEn, digitsArToFa } from '@persian-tools/persian-tools';
import { isPersian, hasPersian, toPersianChars } from '@persian-tools/persian-tools';

@Component({
  selector: 'app-sale',
  templateUrl: './buy.component.html',
  styleUrls: ['./buy.component.css'],
})
export class BuyComponent implements OnInit {
  // #region constructor
  public constructor(
    private logger: LoggerService,
    private guid: Guid,
    public router: Router,
    private modalService: NgbModal,
    public numericService: NumericService,
    private apiService: UserApiService,
    private renderer: Renderer2,
    private dataService: DataService,
    private barcodeService: BarcodeService,
    public calendarService: NewCalendarService,
    private responseService: CustomizeResponseService
  ) {
    this.productType = ProductType.Essentials;
    this.thisBarcodeValue = new DrugCode();
    this.getSearchEntity();
    this.editableItem = new BuyImportRequestDrugModal(
      this.calendarService.GetNow()
    );
    this.stockHelpItem = new StockHelpItem();
    this.level = 1;
    this.getStockData();
    this.getCompany();
    this.getDrugRequirements();
    this.thisValue = new Drug();

    this.searchRequestModel = new PCSearchRequestModel();
    this.searchRequestModel.pageSize = 20;

    this.requestModel = new PCSearchRequestModel();
    this.preInvoiceRequestModel = new PCSearchRequestModel();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'CreditMultiPayment',
          className: 'btn-outline-primary',
          icon: 'fa-regular fa-credit-card',
        },
        {
          name: 'CashMultiPayment',
          className: 'btn-outline-primary',
          icon: 'fa-solid fa-coins',
        },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },

        {
          name: 'Back',
          className: 'btn-outline-primary',
          icon: 'fa-solid fa-reply',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      'List of invoices',
      []
    );

    this.getStocks();
    this.backendJson = new BuyImportRequestModal();
    this.data = new PCTableInputModel(this.searchList, [], false, 1);

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (this.level == 2 || this.level == 1) {
        if (e.key == 'Enter' && this.modalIsOpen == false) {
          if (e.ctrlKey) {
            this.previousFocus();
          } else {
            this.nextFocus();
          }
        }

        if (e.key == 'F2' || e.key == 'PrintScreen') {
          this.saveBuyFactor();
          return;
        }
      }
      if (this.level == 3) {
        if (e.key == 'F2') {
          let el: HTMLElement = this.printBtnElement.nativeElement;
          el.click();
        }
      }
    });

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.addDrugGTN = new FormGroup({
      addDrugGTN: new FormControl(''),
    });
  }
  // #endregion constructor

  // #region properties
  private modalRef: NgbModalRef | undefined;

  floatLabelControl = new FormControl('always' as FloatLabelType);

  public thisItemIndex?: number;
  public drugSearchForm: FormGroup;
  public addDrugGTN: FormGroup;

  public selectDrugList: BuyImportRequestDrugModal[] = [];
  public editableItem: BuyImportRequestDrugModal;
  public editableItemMessage: BuyImportRequestValidationDrugModal =
    new BuyImportRequestValidationDrugModal();
  public searchWithBarcode: string = ``;
  public data?: PCTableInputModel;
  public preInvoiceData?: PCTableInputModel;
  public searchData?: PCTableInputModel;
  public activeAdd: boolean = true;
  public newItem: any = { count: '', stockId: '' };
  public currentFile: any;
  public level: number = 1;
  public fields: any[] = [];
  public searchFields: any[] = [];
  public factorDetail: FactorDetail = new FactorDetail();
  public thisValue: Drug;
  public DrugRequirements: DrugRequirementList = new DrugRequirementList();
  public stockHelpItem: StockHelpItem;

  public taxFie: number = 0;
  public campaignTypeList: any[] = [];
  public searchLoading: boolean = false;
  public searchList: any[] = [];
  public companyList: any[] = [];
  public sellerList: any[] = [];
  public countMessage: string = ``;
  public inventoryCount: number = 0;
  public modalSuccessConfirm: boolean = false;
  public modalCredit: boolean = false;
  public modalLoading: boolean = false;
  public returnDescription: string = '';
  public modalIsOpen: boolean = false;
  public barcode: string = '';
  public backendJson: BuyImportRequestModal;
  public action: PCTableActionInputModel;
  public searchRequestModel: PCSearchRequestModel;
  public requestModel: PCSearchRequestModel;
  public endPoint: string = 'BuyFactor';
  public endPointUrl!: string;
  public paging?: TabelPaging;
  public searchPaging?: TabelPaging;
  public stockList: any[] = [];
  public stockItemList: any[] = [];
  public foundedStock: any;
  public destinationStockSelected: any;
  public preInvoiceRequestModel: PCSearchRequestModel;
  public preInvoicePaging?: TabelPaging;

  public activeAddModal: boolean = false;
  public thisBarcodeValue: DrugCode;
  public loadingModal: boolean = false;

  public addDrugUrl: string = '';
  public genericAddDrugDisable: boolean = false;

  public settingModal = new PCTableOutputModel('Settings', null);

  public modalConfirm: ModalConfirm = new ModalConfirm(
    'Confirm',
    'BuyFactorSaveMessage',
    'Confirm',
    'confirmSave',
    'NotConfirmSave'
  );

  public activeSearch: boolean = true;
  public activeGetBarcodeOnAdd: boolean = false;

  public factorImageList: any[] = [];
  public thisItem: any;
  public showAddButtonUploadImage: boolean = true;
  public buyDiscount: boolean = true;
  public TaxAlert: boolean = true;
  public monthName: string = '';
  public loading: boolean = false;
  public preInvoiceLoading: boolean = false;
  public stocks: any[] = [];
  public stockTypes: any[] = [];
  public listLoading: boolean = true;
  public organizations: any[] = [
    {
      id: 'current.id',
      name: 'current.name',
      persianName: 'current.persianName',
    },
  ];

  public onlineDiscount: number = 0;
  public partnerDiscount: number = 0;
  public cashThisItem: any;
  public creditThisItem: any;

  private focusableItems: FocusableHTMLElement[] = [];
  private rememberItem?: FocusableHTMLElement;
  public confirmModalOpen: boolean = false;
  public genericDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugGeneric',
    'title',
    'title',
    false,
    true,
    true,
    true,
    false
  );

  public drugFormDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugForm',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public drugUsageDropDown: DropDownPagingInput = new DropDownPagingInput(
    'DrugUsage',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public companyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public creatCompanyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Company',
    'name',
    'name',
    false,
    false,
    true,
    true,
    false
  );

  public countryDropDown: DropDownPagingInput = new DropDownPagingInput(
    'Country',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );

  public keepingTypeDropDown: DropDownPagingInput = new DropDownPagingInput(
    'keepingType',
    'persianName',
    'PersianName',
    false,
    false,
    true,
    true,
    false
  );
  // #endregion properties

  // #region ViewChild
  @ViewChild('search') searchElement!: ElementRef;
  @ViewChild('organizationElement') organizationElement!: ElementRef;
  @ViewChild('count') countElement!: ElementRef;
  @ViewChild('nationalid') nationalCodeElement!: ElementRef;
  @ViewChild('drugSearchModal') drugSearchModalElement!: ElementRef;
  @ViewChild('factorDetailModal') factorDetailModalElement!: ElementRef;
  @ViewChild('factorReturnModal') factorReturnModalElement!: ElementRef;
  @ViewChild('removeLack') removeLackModalElement!: ElementRef;
  @ViewChild('printModal') printModalElement!: ElementRef;
  @ViewChild('printBtn') printBtnElement!: ElementRef;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('CashAddModal') CashAddModal!: NgbPopover;
  @ViewChild('CreditAddModal') CreditAddModal!: NgbPopover;
  @ViewChild('CashMultiPayment') CashMultiPaymentModal!: NgbPopover;
  @ViewChild('CreditMultiPayment') CreditMultiPaymentModal!: NgbPopover;
  @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: NgbPopover;
  @ViewChild('preInvoiceFactor') preInvoiceFactorModal!: NgbPopover;
  @ViewChild('addDrug') addDrugModal!: NgbPopover;
  @ViewChild('barcodeScanner') barcodeScanner!: BarcodeScannerComponent;

  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;

  // #endregion ViewChild

  // #region Input
  @Input() productType: ProductType;
  // #endregion Input

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        this.editableItem.drugGenericCode = undefined;
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });

    this.addDrugGTN
      .get('addDrugGTN')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeGetBarcodeOnAdd == true) {
          const regexBarcode: RegExp =
            /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
          if (regexBarcode.test(value)) {
            const groups = value.match(regexBarcode)?.groups;
            // this.thisValue.gtn = String(groups?.['GTN']);
            this.activeGetBarcodeOnAdd = false;
          }
        } else {
          this.activeGetBarcodeOnAdd = true;
        }
      });

    var data = this.dataService.getData('Buy');

    if (data != undefined) {
      this.getOldestData(data);
    }
  }

  public getOldestData(data) {
    this.backendJson.id = data.id;
    this.backendJson.drugDistributorId = data.drugDistributorId;
    this.backendJson.factorId = data.factorId;
    this.backendJson.factorDate = data.factorDate;
    this.backendJson.deliveryDate = data.deliveryDate;
    this.backendJson.discount = data.discount;
    this.backendJson.sellerId = data.sellerId;
    this.backendJson.description = data.description;

    this.backendJson.totalPrice = 0;

    // this.backendJson.drugs.forEach((element) => {
    //   element.packageCount =
    //     (element.count ?? 1) / (element.drugPackageCount ?? 1);
    //   element.totalPrice =
    //     element.packageCount * (element.buyPrice ?? 0) -
    //     (element.buyDiscount ?? 0) +
    //     (element.tax ?? 0);
    //   this.backendJson.totalPrice += element.totalPrice;

    //   element.stocks.forEach((stockElement) => {
    //     stockElement.count =
    //       (stockElement.count ?? 1) / (element.drugPackageCount ?? 1);
    //   });
    // });
    //todo:
    this.getFactorDetail(data.id);


    this.sortTable();
  }

  public searchWithGenericCode() {
    this.editableItem.drugName = undefined;
    if (this.editableItem.drugGenericCode == null) {
      return;
    }
    this.searchDrugByGeneric(this.editableItem.drugGenericCode);
  }

  public checkValidation(): boolean {
    var isValid = true;
    if (
      this.editableItem.drugName == `` ||
      this.editableItem.drugName == null
    ) {
      this.editableItemMessage.drugName = `فیلد نام دارو اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.drugName = ``;
    }
    if (this.editableItem.count == 0 || this.editableItem.count == null) {
      this.editableItemMessage.count = `فیلد تعداد دارو اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.count = ``;
    }
    if (
      this.editableItem.expireDate == `` ||
      this.editableItem.expireDate == null
    ) {
      this.editableItemMessage.expireDate = `فیلد تاریخ انقضا اجباری است`;
      isValid = false;
    } else {
      const now = new Date();
      const sixMonthsAhead = new Date();
      const date = new Date(this.editableItem.expireDate);
      if (date <= sixMonthsAhead) {
        this.editableItemMessage.expireDate = `این دارو تاریخ گذشته است و امکان ثبت آن وجود ندارد`;
        isValid = false;
      } else {
        sixMonthsAhead.setMonth(now.getMonth() + 6);
        if (date < sixMonthsAhead) {
          if (this.editableItemMessage.allowLowExpireDate) {
            this.editableItemMessage.expireDate = ``;
          } else {
            this.modalConfirm.pageMessage = 'confirmLowExpireDate';
            this.modalConfirm.returnAcceptMethod = 'confirmLowExpireDate';
            this.modalConfirm.returnDenyMethod = 'NotConfirmLowExpireDate';
            this.confirmModalOpen = true;
            isValid = false;
          }
        } else {
          this.editableItemMessage.expireDate = ``;
        }
      }
    }
    if (this.editableItem.buyPrice == 0 || this.editableItem.buyPrice == null) {
      this.editableItemMessage.buyPrice = `فیلد قیمت خرید اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.buyPrice = ``;
    }
    if (this.editableItem.stocks.length == 0) {
      if (
        this.editableItem.packageCount != null &&
        this.editableItem.lack != null &&
        this.editableItem.packageCount == this.editableItem.lack
      ) {
        this.editableItemMessage.stockId = ``;
      } else {
        this.editableItemMessage.stockId = `اطلاعات انبار اجباری است`;
        isValid = false;
      }
    } else {
      this.editableItemMessage.stockId = ``;
    }
    if (
      this.editableItem.sellPrice == 0 ||
      this.editableItem.sellPrice == null
    ) {
      this.editableItemMessage.sellPrice = `فیلد قیمت فروش اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.sellPrice = ``;
    }
    // if (
    //   this.editableItem.minimumCount == null ||
    //   this.editableItem.minimumCount.toString() == ``
    // ) {
    //   this.editableItemMessage.minimumCount = `فیلد حداقل موجودی اجباری است`;
    //   isValid = false;
    // } else {
    //   this.editableItemMessage.minimumCount = ``;
    // }
    return isValid;
  }

  public checkAddDrugValidation(): boolean {
    const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
    const minLengthMessage = 'مقدار این فیلد نمیتواند کمتر از 3 کاراکتر باشد';
    let isSucceed = true;

    if (this.thisValue == null) {
      return false;
    }

    if (this.thisBarcodeValue == null || this.thisValue == null) {
      return false;
    }

    if (this.thisValue.name == null || this.thisValue.name == '') {
      this.thisValue.nameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.name.length < 3) {
      this.thisValue.nameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.nameHint = undefined;
    }

    if (
      this.thisValue.persianName == null ||
      this.thisValue.persianName == ''
    ) {
      this.thisValue.persianNameHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.persianName.length < 3) {
      this.thisValue.persianNameHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.persianNameHint = undefined;
    }

    if (
      this.thisValue.drugGenericId == null ||
      this.thisValue.drugGenericId == ''
    ) {
      this.genericDropDown.buttonClass = 'is-invalid';
      this.thisValue.drugGenericHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugGenericHint = undefined;
      this.drugFormDropDown.buttonClass = '';
      this.thisValue.drugGenericId = '00000000-0000-0000-0000-000000000000';
    }

    if (this.thisValue.nameHint == null || this.thisValue.nameHint == '') {
      this.genericDropDown.buttonClass = 'is-invalid';
      this.thisValue.productTypeHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.productTypeHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    if (
      this.thisValue.drugFormId == null ||
      this.thisValue.drugFormId == '00000000-0000-0000-0000-000000000000' ||
      this.thisValue.drugFormId == ''
    ) {
      this.drugFormDropDown.buttonClass = 'is-invalid';
      this.thisValue.drugFormHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugFormHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    if (
      this.thisValue.creatorCompanyId == null ||
      this.thisValue.creatorCompanyId ==
      '00000000-0000-0000-0000-000000000000' ||
      this.thisValue.creatorCompanyId == ''
    ) {
      this.creatCompanyDropDown.buttonClass = 'is-invalid';
      this.thisValue.creatorCompanyHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.creatorCompanyHint = undefined;
      this.drugFormDropDown.buttonClass = '';
    }

    if (
      this.thisValue.drugPackageCount == null ||
      this.thisValue.drugPackageCount.toString() == '' ||
      this.thisValue.drugPackageCount == 0
    ) {
      this.thisValue.drugPackageHint = requiredMessage;
      isSucceed = false;
    } else {
      this.thisValue.drugPackageHint = undefined;
    }

    if (this.thisValue.buyPrice == null || this.thisValue.buyPrice == 0) {
      this.thisValue.buyPriceHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.buyPrice < 500) {
      this.thisValue.buyPriceHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.buyPriceHint = undefined;
    }

    if (this.thisValue.sellPrice == null || this.thisValue.sellPrice == 0) {
      this.thisValue.costHint = requiredMessage;
      isSucceed = false;
    } else if (this.thisValue.sellPrice < 500) {
      this.thisValue.costHint = minLengthMessage;
      isSucceed = false;
    } else {
      this.thisValue.costHint = undefined;
    }

    return isSucceed;
  }

  public completeSuccess() {
    this.modalSuccessConfirm = true;
    this.modalService.dismissAll();
    this.loadingModal = false;
  }

  public addDrugCodeList(drugId: string) {
    try {
      this.loadingModal = true;

      if (this.thisValue == null) {
        return;
      }
      let url = `DrugCode/List`;

      const thisDrugCodeList: any[] = this.thisValue.drugCodes.map(
        (current) => ({
          erxCode: current.erxCode,
          irc: current.irc,
          gtn: current.gtn,
          barCode: current.barCode,
          drugId: drugId,
        })
      );

      console.log(thisDrugCodeList);

      this.apiService
        .postItem(new ApiRequestModel(url, thisDrugCodeList))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.completeSuccess();
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public saveAdd() {
    try {
      if (!this.checkAddDrugValidation()) {
        return;
      }

      this.loadingModal = true;
      let url = `${this.endPoint}`;

      const backendJson = this.toJSON();

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (
            this.thisValue?.drugCodes != null &&
            this.thisValue.drugCodes.length > 0
          ) {
            this.addDrugCodeList(result.data.id);
            return;
          }

          this.completeSuccess();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  private toJSON(): DrugBackEndModel {
    if (this.thisValue == null) {
      return new DrugBackEndModel();
    }

    return {
      name: this.thisValue.name,
      persianName: this.thisValue.persianName,
      attachment: this.thisValue.attachment,
      sellPrice: this.thisValue.sellPrice,
      buyPrice: this.thisValue.buyPrice,
      flavor: this.thisValue.flavor,
      drugGenericId: this.thisValue.drugGenericId,
      drugFormId: this.thisValue.drugFormId,
      drugUsageId: this.thisValue.drugUsageId,
      creatorCompanyId: this.thisValue.creatorCompanyId,
      countryId: this.thisValue.countryId,
      drugPackageCount: this.thisValue.drugPackageCount,
      keepingTypeId: this.thisValue.keepingTypeId,
      licenseCompanyId: this.thisValue.licenseCompanyId,
      productTypeEnum: this.productType,
    };
  }

  public searchStockName(id?: string): string {
    var result = `N/A`;

    if (id == null) {
      return result;
    }

    var foundedStock = this.stockList.find((current) => current.id == id);

    if (foundedStock == undefined) {
      return result;
    }
    return foundedStock.persianName;
  }

  public validateTopForm(): boolean {
    var validate = true;

    if (this.backendJson.factorId == null || this.backendJson.factorId == '') {
      this.backendJson.factorIdMessage = `مقدار این فیلد الزامی است`;
      validate = false;
    } else {
      this.backendJson.factorIdMessage = undefined;
    }

    if (
      this.backendJson.factorDate == null ||
      this.backendJson.factorDate == ''
    ) {
      this.backendJson.factorDateMessage = `مقدار این فیلد الزامی است`;
      validate = false;
    } else {
      this.backendJson.factorDateMessage = undefined;
    }

    if (
      this.backendJson.deliveryDate == null ||
      this.backendJson.deliveryDate == ''
    ) {
      this.backendJson.DeliveryDataMessage = `مقدار این فیلد الزامی است`;
      validate = false;
    } else {
      this.backendJson.DeliveryDataMessage = undefined;
    }

    if (
      this.backendJson.drugDistributorId == null ||
      this.backendJson.drugDistributorId == ''
    ) {
      this.backendJson.drugDistributorIdMessage = `مقدار این فیلد الزامی است`;
      validate = false;
    } else {
      this.backendJson.drugDistributorIdMessage = undefined;
    }

    return validate;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.listLoading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        } else {
          this.requestModel.direction = '';
          this.requestModel.orderBy = '';
        }

        this.requestModel.orderBy = event.data;
        this.generateUrl();
        this.getData();
        break;
      case 'Search':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getData();
        break;
      case 'Paging':
        this.listLoading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getData();
        break;
      case 'PageSize':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getData();
        break;
      case 'Reload':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getData();
        break;
      case 'FactorDetail':
        this.getFactorDetail(event.data.id);
        break;
      case 'Returned':
        this.getFactorDetail(event.data.id);
        break;
      case 'Back':
        this.goToAddPage('listCard');
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'cash':
        this.openModal(this.CashAddModal);
        this.cashThisItem = event.data;
        break;
      case 'closeCash':
        this.modalService.dismissAll();
        break;
      case 'closeUid':
        this.modalService.dismissAll();
        break;
      case 'SaveUid':
        if (event.data == undefined) {
          return;
        }
        this.editableItem.drugUIds = event.data;
        this.modalService.dismissAll();
        break;
      case 'CashMultiPayment':
        this.openModal(this.CashMultiPaymentModal);
        this.cashThisItem = event.data;
        break;
      case 'closeCashMultiPayment':
        this.modalService.dismissAll();
        break;
      case 'CreditMultiPayment':
        this.openModal(this.CreditMultiPaymentModal);
        this.creditThisItem = event.data;
        break;
      case 'closeCreditMultiPayment':
        this.modalService.dismissAll();
        break;
      case 'ScanBarcode':
        this.openModal(this.ScanBarcodeModal);
        break;
      case 'CloseScanBarcode':
        this.modalService.dismissAll();
        break;

      case 'Lack':
        this.getFactorDetail(event.data.id);
        break;
      case 'credit':
        this.openModal(this.CreditAddModal);
        this.creditThisItem = event.data;
        break;
      case 'closeCredit':
        this.modalService.dismissAll();
        break;
      case 'confirmSave':
        this.confirmModalOpen = false;
        this.confirmBuyFactor();
        break;
      case 'NotConfirmSave':
        this.confirmModalOpen = false;
        break;

      case 'confirmLowExpireDate':
        this.confirmModalOpen = false;
        this.editableItemMessage.allowLowExpireDate = true;
        this.editableItemMessage.expireDate = ``;
        break;

      case 'NotConfirmLowExpireDate':
        this.editableItemMessage.expireDate = `مقدار تاریخ انقضا نمیتواند کمتر از 6 ماه باشد`;
        this.editableItemMessage.allowLowExpireDate = false;
        this.confirmModalOpen = false;
        break;

      case 'ReturnCompleted':
        this.modalService.dismissAll();
        this.modalSuccessConfirm = true;
        break;

      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;

      case 'SubmitSetting':
        this.searchFields = event.data;
        this.searchBoxComponent.RebuildColumn();
        break;

      case 'SaveAdd':
        this.saveAdd();
        break;

      case 'CloseModal':
        this.modalService.dismissAll();
        break;

      case 'UpdateSuccess':
        this.modalService.dismissAll();
        this.modalSuccessConfirm = true;
        const thisValue: Drug = event.data;
        this.editableItem.drugName = thisValue.persianName;
        this.editableItem.drugPackageCount = thisValue.drugPackageCount;
        this.editableItem.buyPrice = thisValue.buyPrice;
        this.editableItem.sellPrice = thisValue.sellPrice;
        this.editableItem.partnerPrice = thisValue.sellPrice;
        this.editableItem.onlinePrice = thisValue.sellPrice;
        break;
      default:
        break;
    }
  }

  public openSettings() {
    this.pcsettingModalComponent.openSettingModal();
  }

  public getEntity() {
    this.apiService
      .getEntity(new ApiRequestModel(`${this.endPoint}`))
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.fields = result.data.fields;
            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            setTimeout(() => {
              if (this.searchBoxComponent) {
                this.searchBoxComponent.InitPage();
              } else {
                console.error('PCTableComponent not found');
              }
            }, 2);
            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public getData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items.map((current) => ({
                id: current.id,
                factorId: current.factorId,
                companyName: current.companyName,
                factorDate: current.factorDate,
                totalPrice: current.totalPrice,
                discount: current.discount,
                paidState: current.state,
                haveBuyReturn: current.haveBuyReturn,
                factorDelivery: current.deliveryDate,
                factorNumber: current.factorId,
                payableId: !current.haveShortage,
                haveShortage: current.haveShortage,
              })),
              [
                {
                  name: 'FactorDetail',
                  className: 'btn-outline-primary',
                  icon: 'fa fa-eye',
                },
                {
                  name: 'Returned',
                  className: 'btn-outline-danger',
                  icon: 'fa fa-undo',
                },
                {
                  name: 'cash',
                  className: 'btn-outline-info',
                  icon: 'fa-solid fa-coins',
                  condition: 'payableId',
                },
                {
                  name: 'credit',
                  className: 'btn-outline-info',
                  icon: 'fa-regular fa-credit-card',
                  condition: 'payableId',
                },
                {
                  name: 'Lack',
                  className: 'btn-outline-success',
                  icon: 'fas fa-minus',
                  condition: 'haveShortage',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);

            setTimeout(() => {
              let selectStockPage = document.getElementById('selectStockPage');
              if (selectStockPage) {
                selectStockPage.classList.remove('animate__backInDown');
              }
            }, 2 * 1000);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }

    setTimeout(() => { }, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public getStockData() {
    try {
      this.loading = true;
      let url = `Stock?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.title,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }

    setTimeout(() => { }, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public getCompany() {
    try {
      this.loading = true;
      let url = `DrugDistributor?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.companyList = [];
          }
          if (result.succeeded) {
            this.companyList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.title,
              persianName: current.title,
              companyTypeId: current.companyTypeId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeCompany(event) {
    if (event.id) {
      this.backendJson.drugDistributorId = event.id;
      this.getSeller(this.backendJson.drugDistributorId!);
    }
  }

  public getSeller(drugDistributorId: string) {
    try {
      this.loading = true;
      let url = `Seller/SpecificCompany/${drugDistributorId}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.sellerList = [];
          }
          if (result.succeeded) {
            if (result.data) {
              this.sellerList = result.data.map((current) => ({
                id: current.id,
                name:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                    ' ' +
                    current.lastName +
                    ' - ' +
                    current.mobileNumber,
                persianName:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                    ' ' +
                    current.lastName +
                    ' - ' +
                    current.mobileNumber,
              }));
            } else {
              this.sellerList = [];
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getFactorDetail(
    itemID: string,
  ) {
    try {

      if (this.factorDetail.id != null && this.factorDetail.id == itemID) {
        return;
      }
      this.listLoading = true;
      let url = `${this.endPoint}/FactorDetail/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {

            this.mapFactorDetail(result);

          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }

  private mapFactorDetail(result: any) {
    this.backendJson.drugs = result.data.drugs.map((current) => ({
      ...current,
      packageCount: (current.count ?? 1) / (current.drugPackageCount ?? 1),
      totalPrice: current.count * (current.buyPrice ?? 0) -
        (current.buyDiscount ?? 0) +
        (current.tax ?? 0),
    }));
    this.backendJson.totalPrice = this.backendJson.drugs.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
  }

  private mapFactorDetailWithoutStock(result: any, modalName: any) {
    this.factorDetail = _.cloneDeep(result.data);
    this.factorDetail.drugs = [];
    this.factorDetail.returnDrug = [];

    this.factorDetail.returnDrug = result.data.drugs
      .filter((current) => current.shortageCount > 0)
      .map((current) => ({
        drugId: current.drugId,
        count: current.count,
        shortageCount: current.shortageCount,
        expireDate: current.expireDate,
        lot: current.lot,
        complimentary: current.complimentary,
        buyPrice: current.buyPrice,
        sellPrice: current.sellPrice,
        onlinePrice: current.onlinePrice,
        partnerPrice: current.partnerPrice,
        buyDiscountPersent: current.buyDiscountPersent,
        buyDiscount: current.buyDiscount,
        buyGift: current.buyGift,
        drugName: current.drugName,
        tax: current.tax,
        totalPrice: current.sellPrice * current.count,
        packageCount: current.packageCount,
        stockItemId: '',
        inventory: 0,
        buyFactorDetailId: current.id,
        buyFactorNumber: '',
      }));

    this.openModal(modalName);
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) { }
  }

  public saveBuyFactor() {
    this.modalConfirm = new ModalConfirm(
      'Confirm',
      'BuyFactorSaveMessage',
      'Confirm',
      'confirmSave',
      'NotConfirmSave'
    );

    if (!this.validateTopForm()) {
      return;
    }

    this.confirmModalOpen = true;
  }

  public confirmBuyFactor() {
    try {
      if (!this.validateTopForm()) {
        return;
      }

      const backendJson = {
        id: this.backendJson.id,
        factorId: this.backendJson.factorId,
        factorDate: this.backendJson.factorDate,
        deliveryDate: this.backendJson.deliveryDate,
        totalPrice: digitsFaToEn(this.backendJson.totalPrice.toString()),
        discount: digitsFaToEn(this.backendJson.discount.toString()),
        drugDistributorId: this.backendJson.drugDistributorId,
        sellerId: this.backendJson.sellerId,
        description: this.backendJson.description,
      };

      this.loading = true;

      let url = `${this.endPoint}/BuyImport`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.modalSuccessConfirm = true;
            this.changePreInvoiceStatus(this.backendJson.preInvoiceId);
            this.dataService.setData(undefined, 'Buy');
            this.router.navigate(['/FactorList']);
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.loading = false;
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public SaveBuyFactorEditable() {
    try {
      if (!this.backendJson.id) {
        this.logger.addError('در حال حاضر هیچ رکورد خریدی ثبت نشده', false);
        return;
      }

      const backendJson = {
        id: this.backendJson.id,
        factorId: this.backendJson.factorId,
        factorDate: this.backendJson.factorDate,
        deliveryDate: this.backendJson.deliveryDate,
        totalPrice: +digitsFaToEn(this.backendJson.totalPrice.toString()),
        discount: +digitsFaToEn(this.backendJson.discount.toString()),
        drugDistributorId: this.backendJson.drugDistributorId,
        sellerId: this.backendJson.sellerId,
        description: this.backendJson.description,
      };

      this.loading = true;

      let url = `${this.endPoint}/SaveFactor`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.loading = false;
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  private mappingDataForSubmit() {
    let thisBackendJson: BuyImportRequestModal = _.cloneDeep(this.backendJson);
    for (let index = 0; index < thisBackendJson.drugs.length; index++) {
      let element = thisBackendJson.drugs[index];
      element.expireDate = this.calendarService.ToGregorian(element.expireDate);

      element.tax =
        element.tax == null || element.tax.toString() == '' ? 0 : element.tax;
      element.lot = element.lot == null ? '' : element.lot;

      if (element.drugPackageCount == null) {
        element.drugPackageCount = 1;
      }
      if (element.minimumDigitalCount == null) {
        element.minimumDigitalCount = 1;
      }
      if (element.onlinePrice == null) {
        element.onlinePrice == element.sellPrice;
      }
      if (element.partnerPrice == null) {
        element.partnerPrice == element.sellPrice;
      }

      if (element.lack == null) {
        element.lack = 0;
      }

      element.buyPrice =
        (element.buyPrice! - (element.buyPrice! % element.drugPackageCount)) /
        element.drugPackageCount;
      element.sellPrice =
        (element.sellPrice! - (element.sellPrice! % element.drugPackageCount)) /
        element.drugPackageCount;
      element.onlinePrice =
        (element.onlinePrice! -
          (element.onlinePrice! % element.drugPackageCount)) /
        element.drugPackageCount;
      element.partnerPrice =
        (element.partnerPrice! -
          (element.partnerPrice! % element.drugPackageCount)) /
        element.drugPackageCount;

      element.minimumDigitalCount =
        element.minimumDigitalCount * element.drugPackageCount;
      element.minimumCount =
        (element.minimumCount ?? 0) * element.drugPackageCount;
      for (
        let secondIndex = 0;
        secondIndex < element.stocks.length;
        secondIndex++
      ) {
        let stockElement = element.stocks[secondIndex];
        stockElement.count = stockElement.count! * element.drugPackageCount;
      }

      element.shortageCount = element.lack * element.drugPackageCount;
    }

    thisBackendJson.factorDate = this.calendarService.ToGregorian(
      thisBackendJson.factorDate
    );
    thisBackendJson.deliveryDate = this.calendarService.ToGregorian(
      thisBackendJson.deliveryDate
    );

    thisBackendJson.factorId = thisBackendJson.factorId ?? '';
    thisBackendJson.drugDistributorId =
      thisBackendJson.drugDistributorId ?? this.guid.EmptyGuid();

    return thisBackendJson;
  }

  public goToViewPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 3;
    }, 700);
  }

  public goToAddPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }
    this.selectDrugList = [];
    this.backendJson = new BuyImportRequestModal();

    setTimeout(() => {
      this.level = 1;
    }, 700);
  }

  public goToListPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 0;
    }, 700);

    this.listLoading = true;
    this.getEntity();
    this.generateUrl();
    this.getData();
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.listLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'Paging':
        this.listLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'PageSize':
        this.listLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'SelectItem':
        this.selectDrug(event.data);
        this.modalService.dismissAll();
        break;
      case 'AddItem':
        this.thisValue = new Drug();
        if (this.editableItem.drugName == null) {
          this.editableItem.drugName = '';
        }
        this.thisValue.persianName = this.editableItem.drugName;
        this.openModal(this.addDrugModal);
        break;

      default:
        break;
    }
  }

  public generateSearchUrl(drugName: string): string {
    return `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
  }

  public searchDrugByGeneric(drugGenericCode: string): void {
    try {
      this.searchLoading = true;

      if (!drugGenericCode) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `BuyFactor/AdvanceSearchByGenericCode?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugGenericCode}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public openCamera() {
    this.barcodeScanner.openPopup();
  }

  handleScannedBarcode(event: PCTableOutputModel) {
    const drugName = event.data;
    this.searchDrug(drugName);
  }

  public searchDrug(drugName: string): void {
    try {
      this.searchLoading = true;

      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = '';
      this.editableItem.expireDate = this.barcodeService.ToExpireDate(drugName);
      this.editableItem.lot = this.barcodeService.ToLOT(drugName);
      const gtn = this.barcodeService.ToGTN(drugName);
      if (gtn != undefined) {
        url = this.generateSearchUrl(gtn);
      } else {
        url = this.generateSearchUrl(drugName);
      }
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.searchData = undefined;
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          this.searchBoxComponent.InitPage();
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public checkBarcode() {
    if (this.editableItem.lot == null) {
      return;
    }
    const regexBarcode: RegExp =
      /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
    if (regexBarcode.test(this.editableItem.lot)) {
      const groups = this.editableItem.lot.match(regexBarcode)?.groups;
      this.editableItem.lot = String(groups?.['lot']);

      const expireDate: string = String(groups?.['exp']);

      const regexExpDate: RegExp =
        /(?<year>\d{2})(?<month>\d{2})(?<day>\d{0,2})/;
      if (regexExpDate.test(expireDate)) {
        const expiregroups = expireDate.match(regexExpDate)?.groups;

        const year: number = Number(expiregroups?.['year']);
        const month: string = String(expiregroups?.['month']);
        let day: string = String(expiregroups?.['day']);
        if (day == null || day == '') {
          day = '01';
        }

        this.editableItem.expireDate = `20${year}-${month}-${day}T12:00:00`;
      }
    }
  }

  public selectDrug(item: any) {
    this.editableItem.buyPrice = item.buyPrice * item.drugPackageCount;
    this.editableItem.drugId = item.id;
    this.editableItem.drugName = item.drugBrandPersianName; //persianName
    this.editableItem.onlinePrice = item.sellPrice * item.drugPackageCount; //COST
    this.editableItem.partnerPrice = item.sellPrice * item.drugPackageCount; //Cost
    this.editableItem.drugPackageCount = item.drugPackageCount;
    this.editableItem.sellPrice = item.sellPrice * item.drugPackageCount; //COSt
    this.factor();
    this.modalIsOpen = false;
    this.activeSearch = false;
    setTimeout(() => {
      this.countElement.nativeElement.focus();
    }, 2);

    return;
  }

  public selectDrugAfterAdd(item: any) {
    this.editableItem.buyPrice = item.buyPrice * item.drugPackageCount;
    this.editableItem.drugId = item.id;
    this.editableItem.drugName = item.persianName;
    this.editableItem.onlinePrice = item.cost * item.drugPackageCount;
    this.editableItem.partnerPrice = item.cost * item.drugPackageCount;
    this.editableItem.drugPackageCount = item.drugPackageCount;
    this.editableItem.sellPrice = item.cost * item.drugPackageCount;
    this.factor();
    this.modalIsOpen = false;
    this.activeSearch = false;
    setTimeout(() => {
      this.countElement.nativeElement.focus();
    }, 2);

    return;
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public beTrue() {
    if (!this.countKeyUp()) {
      this.editableItem.count =
        this.editableItem.packageCount! / this.editableItem.drugPackageCount! -
        (this.editableItem.packageCount! %
          this.editableItem.drugPackageCount!) /
        this.editableItem.drugPackageCount!;

      this.editableItem.packageCount =
        this.editableItem.count * this.editableItem.drugPackageCount!;
    }
  }

  public packageKeyUp() {
    if (!this.checkValidationCount()) {
      return;
    }

    this.editableItem.stocks = [];

    this.editableItem.count =
      this.editableItem.packageCount! * this.editableItem.drugPackageCount!;

    this.checkStockActivate();
    this.factor();
  }

  public countKeyUp(): boolean {
    if (!this.checkValidationCount()) {
      return false;
    }

    if (this.editableItem.count! % this.editableItem.drugPackageCount! != 0) {
      if (this.countMessage == ``) {
        this.countMessage = `مغایرت در بسته بندی`;
      }
      this.checkStockActivate();
      this.factor();
      return false;
    } else {
      this.editableItem.packageCount =
        this.editableItem.count! / this.editableItem.drugPackageCount!;
      this.checkStockActivate();
      this.factor();
      return true;
    }
  }

  public checkStockActivate() {
    this.editableItem.stocks = this.editableItem.stocks ?? [];
    this.editableItem.packageCount = this.editableItem.packageCount ?? 0;
    this.editableItem.buyGift = this.editableItem.buyGift ?? 0;
    this.editableItem.lack = this.editableItem.lack ?? 0;

    let sumStock = 0;
    this.editableItem.stocks.forEach((element) => {
      sumStock += element.count ?? 0;
    });

    this.stockHelpItem.maxCount =
      this.editableItem.packageCount +
      this.editableItem.buyGift -
      this.editableItem.lack;

    this.newItem.count = this.stockHelpItem.maxCount - sumStock;
    if (sumStock < this.stockHelpItem.maxCount) {
      this.stockHelpItem.isActive = true;
    } else {
      this.stockHelpItem.isActive = false;
    }
  }

  public checkValidationCount(): boolean {
    if (
      this.editableItem.count == null &&
      this.editableItem.packageCount == null
    ) {
      return false;
    }

    if (this.editableItem.count == null) {
      this.editableItem.count = 0;
    }


    if (this.editableItem.count < 0) {
      this.editableItem.count = 0;
    }

    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }

    if (this.editableItem.packageCount < 0) {
      this.editableItem.packageCount = 0;
    }

    return true;
  }

  public addNewImage() {
    this.thisItem = ``;
    this.showAddButtonUploadImage = false;
  }

  public factor() {
    var count = 1;
    var discount = 0;

    if (this.editableItem.count != undefined) {
      count = this.editableItem.count;
    }

    if (this.editableItem.buyPrice == undefined) {
      this.editableItem.buyPrice = 0;
    }

    // if (this.editableItem.buyDiscountPersent != undefined) {
    //   discount =
    //     (this.editableItem.buyPrice *
    //       count *
    //       this.editableItem.buyDiscountPersent) /
    //     100;
    // } else

    if (this.editableItem.buyDiscount != undefined) {
      discount = this.editableItem.buyDiscount;
    }

    if (this.editableItem.tax == null) {
      this.editableItem.tax = 0;
    }

    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 1;
    }

    this.editableItem.totalPrice =
      this.editableItem.buyPrice * this.editableItem.packageCount -
      discount +
      this.editableItem.tax;
  }

  public totalFactorPrice() {
    this.backendJson.totalPrice = 0;
    for (let index = 0; index < this.backendJson.drugs.length; index++) {
      const element = this.backendJson.drugs[index];

      if (element.totalPrice == null) {
        element.totalPrice = 0;
      }
      element.totalPrice = Number(element.totalPrice);

      this.backendJson.totalPrice =
        element.totalPrice + this.backendJson.totalPrice;
    }
    this.backendJson.totalPrice = Number(this.backendJson.totalPrice);
    this.backendJson.totalPrice =
      this.backendJson.totalPrice - this.backendJson.discount;
  }

  public remove(index) {
    try {
      this.loading = true;
      let item = this.backendJson.drugs[index];
      let url = `BuyFactorDetail/${item.id}`;
      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.backendJson.drugs.splice(index, 1);
            this.totalFactorPrice();
          } else {
          }

          this.loading = false;
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public ImportReturnFactor() {
    try {
      // var backEndJson: FactorStockItemDetailDrug[] = [];
      var backEndJson: any[] = [];

      var isValid = true;
      this.factorDetail.returnDrug.forEach((element) => {
        if (element.returnCount != null && element.returnCount > 0) {
          if (element.inventory == null) {
            this.logger.addError(
              'خطا در دریافت اطلاعات انبار صفحه را به روز کنید',
              false
            );
            return;
          }
          if (element.returnCount > element.inventory) {
            element.alertMessage =
              'مقدار مرجوعی نمیتواند بیشتر از موجودی انبار باشد';
            isValid = false;
          }

          if (element.description == null) {
            element.description = ' ';
          }
          let thisItem = {
            Count: element.returnCount,
            BuyFactorDetailId: element.buyFactorDetailId,
            StockItemId: element.stockItemId,
            BuyFactorNumber: element.buyFactorNumber,
            Description: element.description,
          };

          backEndJson.push(thisItem);
        }
      });

      if (backEndJson.length == 0) {
        this.logger.addError('هیچ موردی برای مرجوع ثبت نشده اس ', false);
        return;
      }

      if (!isValid) {
        return;
      }

      console.log(backEndJson);

      this.listLoading = true;

      const url = `BuyReturn/BuyReturnImport`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.postItem(new ApiRequestModel(url, backEndJson)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.modalSuccessConfirm = true;
            this.modalService.dismissAll();
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => { }
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public editDrugCode(item: DrugCode, index: number) {
    try {
      if (this.thisValue?.id == null) {
        return;
      }
      item.drugId = this.thisValue.id;

      this.thisBarcodeValue = _.cloneDeep(item);

      if (this.thisBarcodeValue.id == null) {
        this.thisBarcodeValue.id = index.toString();
      }
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public saveEditDrugCode() {
    try {
      if (
        this.thisBarcodeValue == null ||
        this.thisBarcodeValue.id == null ||
        !this.checkDrugCodeValidation()
      ) {
        return;
      }

      this.loadingModal = true;

      const thisValue = _.cloneDeep(this.thisBarcodeValue);

      let url = `DrugCode/${this.thisBarcodeValue.id}`;

      this.apiService.patchItem(new ApiRequestModel(url, thisValue)).subscribe(
        (result) => {
          if (result.succeeded && this.thisValue != null) {
            const index = this.thisValue.drugCodes.findIndex(
              (current) => current.id == result.data.id
            );

            this.thisValue.drugCodes[index] = result.data;
            this.thisBarcodeValue = new DrugCode();
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {
          this.loadingModal = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkDrugCodeValidation(): boolean {
    if (this.thisBarcodeValue == null || this.thisValue == null) {
      return false;
    }

    if (
      this.thisBarcodeValue.gtn == null &&
      this.thisBarcodeValue.erxCode == null &&
      this.thisBarcodeValue.irc == null &&
      this.thisBarcodeValue.barCode == null
    ) {
      return false;
    }
    return true;
  }

  public addDrugCode() {
    try {
      this.loadingModal = true;

      if (this.thisValue == null || !this.checkDrugCodeValidation()) {
        return;
      }
      let url = `DrugCode`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.thisBarcodeValue))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              if (this.thisValue != null) {
                this.thisValue.drugCodes.push(result.data);
                this.thisBarcodeValue = new DrugCode();
              }
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingModal = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public addNewDrugCode(drugId?: string) {
    if (this.thisValue == null || !this.checkDrugCodeValidation()) {
      return;
    }

    if (drugId == null || drugId == '') {
      if (this.thisBarcodeValue.id == null) {
        const thisValue = _.cloneDeep(this.thisBarcodeValue);
        this.thisValue.drugCodes.push(thisValue);
        this.thisBarcodeValue = new DrugCode();
      } else {
        const index = _.cloneDeep(this.thisBarcodeValue.id);
        this.thisBarcodeValue.id = undefined;
        this.thisValue.drugCodes[index] = this.thisBarcodeValue;
        this.thisBarcodeValue = new DrugCode();
      }
    } else {
      this.thisBarcodeValue.drugId = drugId;
      if (this.thisBarcodeValue.id == null) {
        this.addDrugCode();
      } else {
        this.saveEditDrugCode();
      }
    }
  }

  public addStock() {
    try {
      if (this.newItem.count == null || this.newItem.count == 0) {
        this.logger.addError(
          'تعداد در انبار نمیتواند خالی و یا صفر باشد',
          false
        );
        return;
      }

      if (this.newItem.stockId == null || this.newItem.stockId == '') {
        this.logger.addError('لطفا یک انبار را انتخاب نمایید ', false);
        return;
      }

      if (this.editableItem.stocks.length >= 3) {
        this.logger.addError(
          'امکان انتقال یک دارو به بیش از 3 انبار امکان پذیر نیست ',
          false
        );
        return;
      }

      const stock = this.stockList.find(
        (current) => current.id == this.newItem.stockId
      );

      const newItemCopy: BuyImportRequestDrugStockModal = {
        count: this.newItem.count,
        stockName: stock.persianName,
        stockId: this.newItem.stockId,
      };
      this.editableItem.stocks.push(newItemCopy);
      this.checkStockActivate();
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public removeStock(index: number) {
    const removeItem = this.editableItem.stocks[index];

    this.editableItem.stocks.splice(index, 1);
    this.checkStockActivate();
  }

  public getStocks() {
    try {
      this.loading = true;

      let url = `Stock?pageNumber=1&pageSize=30&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (!result.data) {
              this.stocks = [];
            } else {
              this.stocks = result.data.items.map((current) => ({
                id: current.id,
                name: current.title,
                type: current.stockTypeName,
              }));

              setTimeout(() => {
                let selectStockPage =
                  document.getElementById('selectStockPage');
                if (selectStockPage) {
                  selectStockPage.classList.remove('animate__backInDown');
                }
              }, 2 * 1000);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getStockType() {
    try {
      this.loading = true;

      let url = `StockType?pageNumber=1&pageSize=30&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (!result.data) {
              this.stockTypes = [];
            } else {
              this.stockTypes = result.data.items.map((current) => ({
                id: current.id,
                name: current.name,
                persianName: current.title,
              }));
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public clearDiscount() {
    if (
      this.editableItem.totalPrice != null &&
      this.editableItem.count != null &&
      this.editableItem.buyPrice != null
    ) {
      this.editableItem.totalPrice =
        this.editableItem.count * this.editableItem.buyPrice;
    } else {
      this.editableItem.totalPrice = 0;
    }
  }

  public normalizeDiscountPercent(): void {
    let discountPercent = Number(
      String(this.editableItem.buyDiscountPersent).replace(/,/g, '')
    );

    if (
      isNaN(discountPercent) ||
      discountPercent === null ||
      discountPercent < 0
    ) {
      discountPercent = 0;
    }

    if (discountPercent > 100) {
      discountPercent = 100;
    }

    this.editableItem.buyDiscountPersent = discountPercent;
  }

  public calcDiscount(changeItemName: string) {
    this.normalizeDiscountPercent();

    const fixTotalPrice =
      (this.editableItem.packageCount ?? 0) * this.editableItem.buyPrice!;

    if (changeItemName == 'Percent') {
      this.editableItem.buyDiscount =
        (fixTotalPrice * this.editableItem.buyDiscountPersent) / 100;
    }

    this.factor();
  }

  public validateInput(event: KeyboardEvent) {
    const allowedChars = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  public confirmItem() {
    if (!this.checkValidation()) {
      return;
    }

    if (this.thisItemIndex != null && this.thisItemIndex >= 0) {
      this.backendJson.drugs.splice(this.thisItemIndex, 1);
      this.thisItemIndex = undefined;
    }

    for (let index = 0; index < this.editableItem.stocks.length; index++) {
      const element = this.editableItem.stocks[index];

      element.stockName = this.searchStockName(element.stockId);
    }

    this.saveItem(this.editableItem);
    this.dataService.setData(this.backendJson, 'Buy');
  }

  private customizeBackendJson(
    editableItem: BuyImportRequestDrugModal
  ): BuyDrugViewModel {
    let backendDetailJson: BuyDrugViewModel = new BuyDrugViewModel(
      editableItem,
      this.backendJson.id
    );

    backendDetailJson.buyPrice =
      (backendDetailJson.buyPrice ?? 0) / (editableItem.drugPackageCount ?? 1);
    backendDetailJson.sellPrice =
      (backendDetailJson.sellPrice ?? 0) / (editableItem.drugPackageCount ?? 1);
    backendDetailJson.onlinePrice =
      (backendDetailJson.onlinePrice ?? 0) /
      (editableItem.drugPackageCount ?? 1);
    backendDetailJson.partnerPrice =
      (backendDetailJson.partnerPrice ?? 0) /
      (editableItem.drugPackageCount ?? 1);

    return backendDetailJson;
  }
  private saveItem(editableItem: BuyImportRequestDrugModal) {
    try {
      this.loading = true;

      let backendDetailJson = this.customizeBackendJson(editableItem);

      let url = `BuyFactorDetail/DetailImport`;
      if (this.editableItem.id != null) {
        url = `BuyFactorDetail/UpdateDetail`;
        backendDetailJson.id = this.editableItem.id;
      }
      this.apiService
        .postItem(new ApiRequestModel(url, backendDetailJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.editableItem.id = result.data.id;
              this.editableItem.dateAdded = result.data.dateAdded;
              this.backendJson.drugs.push(this.editableItem);
              this.backendJson.id = result.data.buyFactorId;
              this.totalFactorPrice();
              this.editableItem = new BuyImportRequestDrugModal(
                this.calendarService.GetNow()
              );
              this.partnerDiscount = 0;
              this.onlineDiscount = 0;
              this.sortTable();
            } else {
            }

            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  private sortTable() {
    this.backendJson.drugs = this.backendJson.drugs.sort((a, b) =>
      a.dateAdded < b.dateAdded ? -1 : 1
    );
  }

  public editItem(index: number, itemModel: any) {
    this.activeSearch = false;
    this.stockHelpItem.addCount = 0;
    itemModel.stocks.forEach((element) => {
      this.stockHelpItem.addCount += element.count;
    });
    this.stockHelpItem.maxCount = itemModel.packageCount;
    if (this.stockHelpItem.maxCount <= this.stockHelpItem.addCount) {
      this.stockHelpItem.isActive = false;
    } else {
      this.stockHelpItem.isActive = true;
    }
    this.clearEditItem();
    this.editableItem = itemModel;
    this.thisItemIndex = index;
  }

  public clearEditItem() {
    this.editableItem = new BuyImportRequestDrugModal(
      this.calendarService.GetNow()
    );
  }

  public generateFocusList() {
    var elements = document.getElementsByClassName('Focusable');
    this.focusableItems = Array.from(elements).map((element, index) => ({
      index,
      element: element as HTMLElement,
    }));
  }

  public nextFocus() {
    if (this.focusableItems.length == 0) {
      this.generateFocusList();
    }

    let focusedElement = document.activeElement;

    let currentItemInArray = this.focusableItems.find(
      (current) =>
        current.element.id == focusedElement?.id &&
        current.element.classList == focusedElement?.classList
    );

    if (currentItemInArray == null && this.rememberItem != null) {
      if (
        this.rememberItem.element.className.indexOf('drop-down-box') >= 0 &&
        this.rememberItem.element.className.indexOf('drop-down-box-open') >= 0
      ) {
        return;
      } else {
        currentItemInArray = this.rememberItem;
      }
    }

    const currentItemIndex =
      currentItemInArray == undefined ? 0 : currentItemInArray.index + 1;

    const nextItemIndex =
      currentItemIndex == this.focusableItems.length ? 7 : currentItemIndex;

    const needFocus = this.focusableItems[nextItemIndex];

    needFocus.element.focus();
    this.rememberItem = needFocus;

    if (needFocus.element instanceof HTMLInputElement) {
      needFocus.element.select();
    }
  }

  public previousFocus() {
    if (this.focusableItems.length == 0) {
      this.generateFocusList();
    }

    let focusedElement = document.activeElement;

    let currentItemInArray = this.focusableItems.find(
      (current) =>
        current.element.id == focusedElement?.id &&
        current.element.classList == focusedElement?.classList
    );

    if (currentItemInArray == null && this.rememberItem != null) {
      if (
        this.rememberItem.element.className.indexOf('drop-down-box') >= 0 &&
        this.rememberItem.element.className.indexOf('drop-down-box-open') >= 0
      ) {
        return;
      } else {
        currentItemInArray = this.rememberItem;
      }
    }

    const currentItemIndex =
      currentItemInArray == undefined ? 0 : currentItemInArray.index - 1;

    const nextItemIndex =
      currentItemIndex == this.focusableItems.length ? 7 : currentItemIndex;

    const needFocus = this.focusableItems[nextItemIndex];

    needFocus.element.focus();
    this.rememberItem = needFocus;

    if (needFocus.element instanceof HTMLInputElement) {
      needFocus.element.select();
    }
  }

  public setOtherSalePrice() {
    if (this.editableItem.sellPrice == null) {
      this.editableItem.sellPrice = 0;
    }
    this.editableItem.onlinePrice =
      this.editableItem.sellPrice -
      (this.editableItem.sellPrice * this.onlineDiscount) / 100;
    this.editableItem.partnerPrice =
      this.editableItem.sellPrice -
      (this.editableItem.sellPrice * this.partnerDiscount) / 100;
  }

  public setOnStockCount() {
    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }

    if (this.editableItem.lack == null) {
      this.editableItem.lack = 0;
    }

    if (this.editableItem.buyGift == null) {
      this.editableItem.buyGift = 0;
    }
    this.newItem.count =
      this.editableItem.packageCount -
      this.editableItem.lack +
      this.editableItem.buyGift;
  }

  public openPreInvoice() {
    this.openModal(this.preInvoiceFactorModal);
    this.getPreInvoiceData();
  }

  public getPreInvoiceData() {
    try {
      this.preInvoiceLoading = true;
      const url = `BuyPreInvoice/Active?pageNumber=${this.preInvoiceRequestModel.pageNumber}&pageSize=${this.preInvoiceRequestModel.pageSize}&paging=${this.preInvoiceRequestModel.paging}&orderBy=${this.preInvoiceRequestModel.orderBy}&direction=${this.preInvoiceRequestModel.direction}&search=${this.preInvoiceRequestModel.search}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            this.preInvoiceData = new PCTableInputModel(
              result.data?.items.map((current) => ({
                id: current.id,
                companyName: current.companyName,
                preInvoiceDate: current.preInvoiceDate,
                preInvoiceId: current.preInvoiceId,
              })),
              [],
              true,
              firstItemOnPage,
              this.preInvoiceRequestModel.orderBy,
              this.preInvoiceRequestModel.direction
            );

            this.preInvoicePaging =
              this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.preInvoiceLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.preInvoiceLoading = false;
        },
        () => {
          this.preInvoiceLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.preInvoiceLoading = false;
    }
  }

  public clearPage() {
    this.backendJson = new BuyImportRequestModal();
  }

  public getPreInvoiceDetail(id: string) {
    try {
      this.clearPage();
      this.preInvoiceLoading = true;
      const url = `BuyPreInvoice/PreInvoiceDetail/${id}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `get Without Page`);
          if (result.succeeded) {
            if (result.data != null) {
              this.backendJson.preInvoiceId = result.data.id;
              this.backendJson.drugDistributorId =
                result.data.drugDistributorId;
              this.backendJson.sellerId = result.data.sellerId;
              this.backendJson.description = result.data.description;
              this.backendJson.factorDate = result.dateTime;
              this.backendJson.deliveryDate = result.dateTime;

              result.data.drugs.forEach((element) => {
                let thisItem = new BuyImportRequestDrugModal(
                  this.calendarService.GetNow()
                );
                thisItem.drugId = element.drugId;
                thisItem.drugName = element.drugName;
                thisItem.packageCount = element.count;
                thisItem.drugPackageCount = element.drugPackageCount;
                thisItem.count = element.count * element.drugPackageCount;

                this.backendJson.drugs.push(thisItem);
              });
            }
            const test = result.data;
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.modalService.dismissAll();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalService.dismissAll();
        },
        () => {
          this.preInvoiceLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalService.dismissAll();
    }
  }

  public parentActionPreInvoice(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.preInvoiceLoading = true;
        if (this.preInvoiceRequestModel.orderBy == '') {
          this.preInvoiceRequestModel.direction = 'asd';
        } else if (this.preInvoiceRequestModel.orderBy != event.data) {
          this.preInvoiceRequestModel.direction = 'asd';
        } else if (this.preInvoiceRequestModel.direction == '') {
          this.preInvoiceRequestModel.direction = 'asd';
        } else if (this.preInvoiceRequestModel.direction == 'asd') {
          this.preInvoiceRequestModel.direction = 'desc';
        } else {
          this.preInvoiceRequestModel.direction = '';
          this.preInvoiceRequestModel.orderBy = '';
        }

        this.preInvoiceRequestModel.orderBy = event.data;
        this.getPreInvoiceData();
        break;
      case 'Paging':
        this.preInvoiceLoading = true;

        this.preInvoiceRequestModel.pageNumber = event.data;
        this.getPreInvoiceData();
        break;
      case 'PageSize':
        this.preInvoiceLoading = true;
        this.preInvoiceRequestModel.pageSize = event.data;
        this.getPreInvoiceData();
        break;
      case 'SelectItem':
        this.getPreInvoiceDetail(event.data.id);
        break;
      default:
        break;
    }
  }

  public changePreInvoiceStatus(preInvoiceId?: string) {
    try {
      if (preInvoiceId == null) {
        return;
      }

      if (this.backendJson.drugs.length == 0) {
        return;
      }

      const url = `BuyPreInvoice/SetComplete/${preInvoiceId}`;

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          if (result.succeeded) {
          } else {
            this.logger.addBackEndMessage(result);
          }
        },

        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public getDrugRequirements() {
    if (this.DrugRequirements.productTypeList.length == 0) {
      this.DrugRequirements.productTypeList = Object.keys(ProductType)
        .filter((key) => !isNaN(Number(ProductType[key])))
        .map((key) => ({ value: ProductType[key], name: key }));
    }
  }

  public getGenericList() {
    if (this.thisValue.productType == null) {
      this.addDrugUrl = `Drug`;
      this.genericDropDown.isDisable = false;
      this.thisValue.productType = ProductType.ChemicalDrug;
      return;
    }
    const productType =
      ProductType[
      <keyof typeof ProductType>ProductType[this.thisValue!.productType]
      ];

    switch (productType) {
      case ProductType.ChemicalDrug:
        this.addDrugUrl = `Drug`;
        this.genericDropDown.isDisable = false;
        break;

      case ProductType.Cosmetic:
        this.addDrugUrl = `Cosmetic`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.Essentials:
        this.addDrugUrl = `Essential`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.NaturalRemedy:
        this.addDrugUrl = `NaturalRemedy`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.Supplement:
        this.addDrugUrl = `Supplement`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.TraditionalDrug:
        this.addDrugUrl = `TraditionalDrug`;
        this.genericDropDown.isDisable = true;
        break;

      case ProductType.MilkPowder:
        this.addDrugUrl = `MilkPowder`;
        this.genericDropDown.isDisable = true;
        break;

      default:
        this.addDrugUrl = `Drug`;
        this.genericDropDown.isDisable = false;
        break;
    }
  }

  public validationAddDrug() {
    let requestIsValid = true;

    if (this.thisValue.productType != 0) {
      this.thisValue.drugGenericId = this.guid.EmptyGuid();
    }

    if (
      this.thisValue.drugGenericId == null ||
      this.thisValue.drugGenericId == ''
    ) {
      this.thisValue.drugGenericHint = 'Required';
      requestIsValid = false;
    } else {
      this.thisValue.drugGenericHint = undefined;
    }

    if (this.thisValue.name == null || this.thisValue.name == '') {
      this.thisValue.nameHint = 'Required';
      requestIsValid = false;
    } else {
      this.thisValue.nameHint = undefined;
    }

    // if (this.thisValue.gtn == null || this.thisValue.gtn == '') {
    //   this.thisValue.gtnHint = 'Required';
    //   requestIsValid = false;
    // } else {
    //   this.thisValue.gtnHint = undefined;
    // }

    if (this.thisValue.drugFormId == null || this.thisValue.drugFormId == '') {
      this.thisValue.drugFormHint = 'Required';
      requestIsValid = false;
    } else {
      this.thisValue.drugFormHint = undefined;
    }

    if (
      this.thisValue.drugPackageCount == null ||
      this.thisValue.drugPackageCount == 0
    ) {
      this.thisValue.drugPackageHint = 'Required';
      requestIsValid = false;
    } else {
      this.thisValue.drugPackageHint = undefined;
    }

    return requestIsValid;
  }

  public addToBackendDrug() {
    if (!this.checkAddDrugValidation()) {
      return;
    }

    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.addDrugUrl))
      ) {
        return;
      }

      let backendJson = {
        name: this.thisValue.name,
        persianName: this.thisValue.persianName,
        // erxCode: this.thisValue.erxCode,
        // irc: this.thisValue.irc,
        // gtn: this.thisValue.gtn,
        attachment: this.thisValue.attachment,
        sellPrice: this.thisValue.sellPrice,
        buyPrice: this.thisValue.buyPrice,
        flavor: this.thisValue.flavor,
        drugGenericId: this.thisValue.drugGenericId,
        drugFormId: this.thisValue.drugFormId,
        drugUsageId: this.thisValue.drugUsageId,
        creatorCompanyId: this.thisValue.creatorCompanyId,
        countryId: this.thisValue.countryId,
        drugPackageCount: this.thisValue.drugPackageCount,
        keepingTypeId: this.thisValue.keepingTypeId,
        licenseCompanyId: this.thisValue.licenseCompanyId,
        productType: this.thisValue.productType,
      };

      console.log(backendJson);

      this.apiService
        .postItem(new ApiRequestModel(this.addDrugUrl, backendJson))
        .subscribe(
          (result) => {
            this.logger.addResponseLog(this.addDrugUrl, result, `POST`);
            if (result.succeeded) {
              this.modalService.dismissAll();
              this.selectDrugAfterAdd(result.data);
              this.modalSuccessConfirm = true;
            } else {
              this.logger.addBackEndMessage(result);
            }
          },
          (error) => {
            this.apiService.AddErrorLog(error);
          },
          () => { }
        );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public lackKeyUp() {

    this.editableItem.stocks = [];
    if (this.editableItem.packageCount == null) {
      this.editableItem.packageCount = 0;
    }

    if (
      this.editableItem.lack == null ||
      this.editableItem.lack.toString() == ''
    ) {
      this.editableItem.lack = 0;
    }

    this.editableItem.lack = parseInt(this.editableItem.lack.toString(), 10);
    this.editableItem.lack = this.numericService.checkMaxBusiness(
      this.editableItem.packageCount,
      this.editableItem.lack
    );
    this.checkStockActivate();
    this.setOnStockCount();
  }
}
